import { render, staticRenderFns } from "./VoiceHelper.vue?vue&type=template&id=78466f79&"
import script from "./VoiceHelper.vue?vue&type=script&lang=js&"
export * from "./VoiceHelper.vue?vue&type=script&lang=js&"
import style0 from "./VoiceHelper.vue?vue&type=style&index=0&id=78466f79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports